/* Homefully voices (11 Oct 2026): the creator and customer videos (.vid), in the video row (.voices) or alone in a photo slot.
   Tap plays with sound, tap again pauses; one video at a time; a video that scrolls out of view pauses; the honey line shows
   how far in it is; at the end it goes back to its poster. The row's own arrows (data-vtarget) scroll it.
   Videos load nothing until tapped (preload="none"), so the row costs the page only its posters. */
(function(){
  function init(){
    var reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cards=[].slice.call(document.querySelectorAll('.vid'));
    cards.forEach(function(v){
      var el=v.querySelector('video'),b=v.querySelector('button'),bar=v.querySelector('.prog i'),what=b.getAttribute('aria-label').replace(/^Play /,''),raf=0;
      function tick(){bar.style.transform='scaleX('+(el.duration?el.currentTime/el.duration:0)+')';if(!el.paused)raf=requestAnimationFrame(tick)}
      function state(on){v.classList.toggle('playing',on);b.setAttribute('aria-label',(on?'Pause ':'Play ')+what);cancelAnimationFrame(raf);if(on)tick()}
      b.addEventListener('click',function(){
        if(el.paused){cards.forEach(function(o){var ov=o.querySelector('video');if(ov!==el&&!ov.paused)ov.pause()});el.play()}else el.pause()});
      el.addEventListener('play',function(){state(true)});
      el.addEventListener('pause',function(){state(false)});
      el.addEventListener('ended',function(){bar.style.transform='scaleX(0)';el.load()});
      if('IntersectionObserver' in window)new IntersectionObserver(function(es){es.forEach(function(e){if(!e.isIntersecting&&!el.paused)el.pause()})},{threshold:.25}).observe(v);
    });
    document.querySelectorAll('.voices').forEach(function(sec){
      sec.querySelectorAll('.arrows[data-vtarget]').forEach(function(a){var sc=document.getElementById(a.dataset.vtarget);
        a.querySelectorAll('button').forEach(function(btn){btn.addEventListener('click',function(){sc.scrollBy({left:(+btn.dataset.dir)*sc.clientWidth*.8,behavior:reduced?'auto':'smooth'})})});
        /* no arrows when every video already fits */
        function fit(){a.style.display=sc.scrollWidth>sc.clientWidth+4?'':'none'}fit();addEventListener('resize',fit)});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
